<template>
  <v-container fluid grid-list-lg>
    <v-layout column wrap>
      <v-flex d-flex xs12>
        <v-layout row wrap align-center justify-center>
          <v-flex xs12 sm5 d-flex class="title"> System Prompt </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-layout row wrap align-center justify-center>
        <v-flex xs8>
          <p class="mb-4 grey--text">
            This is a system prompt for ooca chat feature in ooca application. Once saved, this system prompt will be
            used immediately, so please be careful.
          </p>
          <v-textarea label="Prompt" v-model="prompt" outlined counter height="400"></v-textarea>
          <v-btn @click="submit" color="accent">Save</v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import store from '../../store';
import settingService from '../../services/setting';
export default Vue.extend({
  store,
  data: () => ({
    prompt: '',
  }),
  computed: {},
  watch: {},
  created() {},
  mounted() {
    settingService.getAdmin('llm_chat_system_prompt').then((data) => {
      this.prompt = data.prompt || '';
    });
  },
  methods: {
    submit() {
      const prompt = (this.prompt || '').trim();
      if (prompt === '') {
        return;
      }

      this.$root
        .$confirm('Update system prompt', `Are you sure you want to update the system prompt?"`, {
          color: 'primary',
          submitText: 'Confirm',
        })
        .then((confirm) => {
          if (confirm) {
            settingService
              .updateAdmin('llm_chat_system_prompt', JSON.stringify({ prompt }))
              .then(() => {
                this.$notify({
                  title: 'Success',
                  text: 'A setting is updated successfully.',
                  type: 'success',
                });
              })
              .catch((error) => {
                this.$notify({
                  title: 'Failed',
                  text: `Cannot update the setting: ${error}`,
                  type: 'error',
                });
              });
          }
        });
    },
  },
});
</script>

<style scoped></style>
